<template>
  <div class="app-router">
    <h3 class="font-weight-bold">
      <div class="d-flex flex-row align-center text-uppercase">
        <v-img width="30" max-width="30" class="mr-4" src="/assets/seller/store.svg"></v-img>
        <span v-if="detailStore" class="primary--text">{{ detailStore.store_name }}</span>
      </div>
    </h3>
    <div class="text-subtitle-2 pb-4 pt-2">Berikut ini adalah ringkasan informasi tentang toko Anda.</div>

    <!-- alert jika toko sedang tutup untuk reminder -->
    <template v-if="storeIsOpen == 'Tutup'">
      <v-alert
        text
        prominent
        type="error"
        icon="mdi-store-off-outline"
      >
        <span class="d-block pl-3" style="font-size: 15px;font-weight: 500;">
          Saat ini toko Anda sedang <strong>Tutup</strong>, Anda tidak dapat menerima pesanan langsung dari pembeli. Lakukan pengaturan pada informasi 'Status Toko' untuk membuka kembali toko Anda.
        </span>
      </v-alert>
    </template>

    <v-card flat outlined>
      <v-card-text class="py-0">
        <v-tabs v-model="intabs" :show-arrows="true">
          <v-tab class="text-caption text-capitalize font-weight-bold">Informasi Toko</v-tab>
          <v-tab class="text-caption text-capitalize font-weight-bold">Update Profile</v-tab>
          <v-tab class="text-caption text-capitalize font-weight-bold">Update Password</v-tab>

          <v-tab-item>
            <profileData :profile="detailStore"></profileData>
          </v-tab-item>

          <v-tab-item>
            <updateProfile></updateProfile>
          </v-tab-item>
          
          <v-tab-item>
            <updatePassword></updatePassword>
          </v-tab-item>
         </v-tabs>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import profileData from './components/profileData'
import updateProfile from './components/updateProfile'
import updatePassword from './components/updatePassword'

export default {
  name: 'seller-profile-store',
  components: { profileData, updateProfile, updatePassword },
  data() {
    return {
      intabs: null,
      loading: false
    }
  },
  computed: {
    ...mapState('storeSeller', ['detailStore', 'storeIsOpen'])
  },
  methods: {
    ...mapActions('storeSeller', ['getStoreDetail']),
  },

  async created() {
    await this.getStoreDetail()
  }
}
</script>